// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/SearchResults/SearchResults.css
// module id = 1428
// module chunks = 0